import { React, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  makeStyles,
  TextField,
  Avatar,
  Box,
  CardMedia,
} from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import Autocomplete from "@material-ui/lab/Autocomplete";

import SFDialogTitle from "../../../../../components/SFDialogTitle";
//import ScbIcon from "../../../../../assets/icons/paymentIcon/SCBICON.png";
import usePaymentChannels from "../../../../../hooks/usePaymentChannels";
import { PaymentChannel } from "../../../../../models/Payment";
import { useTranslate } from "react-admin";
const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "50px auto",
    width: 800,
    maxWidth: 1200,
    borderRadius: "10px",
  },
  dialogContainer: {
    margin: "0 auto",
  },
  title: {
    color: theme.orange,
    fontSize: 30,
    fontWeight: "bold",
    margin: "20px auto 0",
    display: "table",
  },

  container: {
    // backgroundColor: "red",
    display: "grid",
    gridTemplateColumns: "72px 72px 72px 72px 72px 72px 72px 72px 72px",

    rowGap: "10px",
    columnGap: "5px",
    margin: " 20px ",
  },
  box: {
    display: "block",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  toggleButton: {
    width: 68,
    height: 68,
    // height: 68,
    color: "grey",

    border: "0 solid #FA9917",
  },
  selected: {
    width: 68,
    height: 68,
    mixBlendMode: "normal",

    border: "4px solid #FA9917",
    boxShadow: " 0px -1px 4px 2px #FA9917",
  },
  bankIcon: {
    width: 68,
    height: 68,
  },
  autocomplete: {
    borderRadius: 10,
  },
  textfield: {
    width: 270,
    margin: "20px 0",
    [`& fieldset`]: {
      borderRadius: 5,
    },
  },

  disabled: {
    backGroundColor: "grey",
    borderRadius: 0,
    height: 69,
  },
  bottomButton: {
    backgroundColor: "#FA9917",
    borderRadius: 0,
    height: 69,
  },
}));
let bankSeller = [];

let cardType = [];
function CreditDebit({
  openDialog,
  handleDialogClose,
  onSubmit,
  paymentValue,
}) {
  const classes = useStyles();

  const { loading, banks, getCardsfromBank, getDefaultCard, getDefaultBank } =
    usePaymentChannels();
  //   const [value, setValue] = useState(options[0]);
  const [selectedCard, setSelectedCard] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [buttonIsDisable, setButtonIsDisable] = useState(false);
  const translate = useTranslate();
  const handleToggleBankButton = (newSelectedBank) => {
    if (selectedBank === newSelectedBank) {
      setSelectedBank("");
      setSelectedCard("");
    } else {
      setSelectedBank(newSelectedBank);
      setSelectedCard("");
      setButtonIsDisable(false); //
    }
    setSelectedCard("");
  };

  if (loading) return null;

  if (banks) {
    bankSeller = banks.map((bank) => ({
      icon: bank.image_url,
      name: bank.name,
      id: bank.id,
    }));
  }

  if (selectedBank && selectedBank !== "") {
    const cardsToDisplay = getCardsfromBank(selectedBank.name);

    cardType = cardsToDisplay.map((card) => ({
      icon: card.image_url,
      name: card.name,
      id: card.id,
    }));
  }

  return (
    <Dialog
      fullWidth
      onClose={() => {
        handleDialogClose();
      }}
      aria-labelledby="customized-dialog-title"
      open={openDialog}
      classes={{ root: classes.dialogContainer, paper: classes.paper }}
      // style={{}}
    >
      <SFDialogTitle
        title={translate("ra.text.paymentMethod.paidbyCard")}
        onClose={() => handleDialogClose()}
      />

      <DialogContent>
        <Typography>
          1. {translate("ra.text.paymentMethod.selectCustomerBank")}
        </Typography>
        <Box style={{ display: "flex", justifyContent: "left" }}>
          <ToggleButtonGroup classes={{ root: classes.container }}>
            {bankSeller.map((bank) => {
              return (
                <Box classes={{ root: classes.box }}>
                  <ToggleButton
                    value={bank.name}
                    onClick={() => handleToggleBankButton(bank)}
                    selected={selectedBank.name === bank.name}
                    classes={{
                      root:
                        selectedBank.name === bank.name
                          ? classes.selected
                          : classes.toggleButton,
                    }}
                  >
                    <Avatar
                      className={classes.bankIcon}
                      variant="square"
                      src={bank.icon}
                      alt={bank.name}
                    >
                      {bank.name}
                    </Avatar>
                  </ToggleButton>
                </Box>
              );
            })}
          </ToggleButtonGroup>
        </Box>
        <Typography>
          {" "}
          2.{translate("ra.text.paymentMethod.selectCardType")}
        </Typography>
        <Autocomplete
          defaultValue={selectedCard ? selectedCard.name : ""}
          value={selectedCard ? selectedCard.name : ""}
          classes={{ root: classes.autocomplete }}
          options={cardType}
          getOptionSelected={(option) => {
            if (option.name) return option.name;
            else return option;
          }}
          getOptionLabel={(option) => {
            if (option.name) return option.name;
            else return option;
          }}
          onChange={(_, newInputValue) => {
            setSelectedCard(newInputValue);
            setButtonIsDisable(false);
          }}
          noOptionsText={translate("ra.text.paymentMethod.noOption")}
          renderOption={(option) => (
            <>
              <CardMedia
                image={option.icon}
                style={{ width: 53, height: 34 }}
              />
              <Typography style={{ marginLeft: 7, fontSize: 14 }}>
                {option.name}
              </Typography>
            </>
          )}
          renderInput={(params) => (
            <TextField
              variant="outlined"
              // underlineShow={false}
              classes={{ root: classes.textfield }}
              placeholder={translate("ra.text.paymentMethod.selectCardType")}
              {...params}
            />
          )}
        />
        <Box style={{ height: 100 }}></Box>
      </DialogContent>
      <Button
        autoFocus
        disabled={buttonIsDisable}
        // classes={{ root: classes.bottomButton, disabled: classes.disabled }}
        style={{
          // alignContent: "center",
          backgroundColor: buttonIsDisable ? "#D8D8D8" : "#FA9917",
          borderRadius: 0,
          height: 69,
        }}
        onClick={() => {
          let cardId, bankId, cardName, bankName;
          if (!selectedCard) {
            cardId = getDefaultCard().id;
            cardName = getDefaultCard().name;
          } else {
            cardId = selectedCard.id;
            cardName = selectedCard.name;
          }

          if (!selectedBank) {
            bankId = getDefaultBank().id;
            bankName = getDefaultBank().name;
          } else {
            bankId = selectedBank.id;
            bankName = selectedBank.name;
          }
          onSubmit(
            new PaymentChannel({
              type: "Credit-Debit",
              amount: paymentValue,
              instituteId: bankId,
              instituteName: bankName,
              cardId: cardId,
              cardName: cardName,
            })
          );
        }}
      >
        <Typography align="center" style={{ color: "white", fontSize: 26 }}>
          {translate("ra.text.paymentMethod.pay")}
        </Typography>
      </Button>
    </Dialog>
  );
}

export default CreditDebit;
